import listasApi from '@/app/services/listas';

export default {
  namespaced: true,
  state: {
    clientes: [],
    vendedores: [],
    fornecedores: [],
    bancos: [],
    perfis: [],
    lotes: [],
    lojas: [],
    variacoes: [],
    grupos: [],
    subgrupos: [],
  },

  getters: {
    clientes(state) {
      return state.clientes.map((cliente) => {
        return {
          text: cliente.id + ' - ' + cliente.razao,
          value: cliente.id,
        };
      });
    },

    getClienteById(state) {
      return (id) => {
        return state.clientes.find((cliente) => cliente.id === id);
      };
    },

    vendedores(state) {
      return state.vendedores.map((vendedor) => {
        return {
          text: vendedor.id + ' - ' + vendedor.nome,
          value: vendedor.id,
        };
      });
    },

    fornecedores(state) {
      return state.fornecedores.map((fornecedor) => {
        return {
          text: fornecedor.id + " - " + fornecedor.razao,
          // text: fornecedor.razao,
          value: fornecedor.id,
        };
      });
    },

    bancos(state) {
      return state.bancos.map((banco) => {
        return {
          text: banco.codigo + ' - ' + banco.descricao,
          value: banco.codigo,
        };
      });
    },

    perfis(state) {
      return state.perfis.map((perfil) => {
        return {
          text: perfil.descricao,
          value: perfil.id,
        };
      });
    },

    lotes(state) {
      return state.lotes.map((lote) => {
        return {
          text: lote.id + ' - ' + lote.descricao,
          value: lote.id,
        };
      });
    },

    lojas(state) {
      return state.lojas.map((loja) => {
        return {
          text: loja.id + ' - ' + loja.nome,
          value: loja.id,
        };
      });
    },

    variacoes(state) {
      return state.variacoes.map((variacao) => {
        return {
          text: variacao.descricao,
          value: variacao.id,
        };
      });
    },

    grupos(state) {
      return state.grupos.map((grupo) => {
        return {
          text: grupo.id + ' - ' + grupo.descricao,
          value: grupo.id,
        };
      });
    },

    subgrupos(state) {
      return state.subgrupos.map((subgrupo) => {
        return {
          text: subgrupo.id + ' - ' + subgrupo.descricao,
          value: subgrupo.id,
        };
      });
    },
  },

  mutations: {
    SET_CLIENTES(state, clientes) {
      state.clientes = clientes;
    },

    SET_VENDEDORES(state, vendedores) {
      state.vendedores = vendedores;
    },

    SET_FORNECEDORES(state, fornecedores) {
      state.fornecedores = fornecedores;
    },

    SET_BANCOS(state, bancos) {
      state.bancos = bancos;
    },

    SET_PERFIS(state, perfis) {
      state.perfis = perfis;
    },

    SET_LOTES(state, lotes) {
      state.lotes = lotes;
    },

    SET_LOJAS(state, lojas) {
      state.lojas = lojas;
    },

    SET_VARIACOES(state, variacoes) {
      state.variacoes = variacoes;
    },

    SET_GRUPOS(state, grupos) {
      state.grupos = grupos;
    },

    SET_SUBGRUPOS(state, subgrupos) {
      state.subgrupos = subgrupos;
    },
  },

  actions: {
    async todas({ commit, dispatch }) {
      dispatch('clientes');
      dispatch('vendedores');
      dispatch('fornecedores');
    },

    async clientes({ commit }) {
      let clientes = await listasApi.clientes();
      commit('SET_CLIENTES', clientes);
    },

    async vendedores({ commit }) {
      let vendedores = await listasApi.vendedores();
      commit('SET_VENDEDORES', vendedores);
    },

    async fornecedores({ commit }) {
      let fornecedores = await listasApi.fornecedores();
      commit('SET_FORNECEDORES', fornecedores);
    },

    async bancos({ commit }) {
      let bancos = await listasApi.bancos();
      commit('SET_BANCOS', bancos);
    },

    async perfis({ commit }) {
      let perfis = await listasApi.perfis();
      commit('SET_PERFIS', perfis);
    },

    async lotes({ commit }) {
      let lotes = await listasApi.lotes();
      commit('SET_LOTES', lotes);
    },

    async lojas({ commit }) {
      let lojas = await listasApi.lojas();
      commit('SET_LOJAS', lojas);
    },

    async variacoes({ commit }) {
      let variacoes = await listasApi.variacoes();
      commit('SET_VARIACOES', variacoes);
    },

    async grupos({commit}) {
      let grupos = await listasApi.grupos();
      commit('SET_GRUPOS', grupos);
    },

    async subgrupos({commit}) {
      let subgrupos = await listasApi.subgrupos();
      commit('SET_SUBGRUPOS', subgrupos);
    },

    async fetchListas({state}, listas) {
      const lists = await listasApi.fetchListas(listas);

      Object.keys(lists).forEach((key) => {
        state[key] = lists[key];
      });
    }
  },
};
